<template>
    <td class="flow-step__selections-summary-item">
        <span class="flow-step__selections-summary-item-name">{{stepResult.Name}}: </span>
        <span class="flow-step__selections-summary-item-value" v-for="stepResultItem in stepResult.Items">
            <span v-if="stepResult.MultiValue">{{stepResultItem.Value}} </span><span>{{stepResultItem.Name}}<br /></span>
        </span>
    </td>
</template>

<script>

    export default {
        name: "flowStepSelectionsSummaryItem",
        props: ["stepResult"],
    };
</script>
